import React from 'react';
import styles from '../styles.module.css';

// Vertical toolbar divider
const ToolbarVDivider = () => {
  return <div className={styles.toolbarVDivider}></div>;
};

export default ToolbarVDivider;
